// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.settings-modal {
  background-color: #faf8f5;
  color: black;
  padding: 32px 24px;
  border-radius: 16px;
  width: 450px;
  max-height: 90vh;
  overflow-y: auto;
}

.settings-modal h2 {
  margin-top: 0;
  color: black;
  font-size: 24px;
  text-align: center;
  font-family: 'Crimson', serif;
}

.settings-section {
    padding: 14px 0;
    border-bottom: 1px solid rgba(135, 134, 127, 0.25);
    border-radius: 5px;
}

.settings-section:last-of-type {
  border: none;
}

.settings-section h3 {
  margin-top: 0;
  margin-bottom: 10px;
  color: black;
  font-size: 18px;
}

.close-button, .audio-control, .font-size-button {
  background-color: #f7f4ef;
  color: black;
  border: none;
  border-radius: 5px;
  border: 1px solid #D1D5DB;
  padding: 8px 12px;
  cursor: pointer;
  transition: background-color 0.3s;
  font-size: 14px;
}

.close-button:hover, .audio-control:hover, .font-size-button:hover {
transition: ease-in-out 0.2;
}

.close-button {
  width: 100%;
  margin-top: 10px;
}

.volume-control svg {
  margin-right: 10px;
  width: 28px !important;
  height: 28px !important;
}

.audio-controls, .volume-control, .font-size-controls {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.audio-progress {
  flex-grow: 1;
  margin: 0 10px;
}

.progress-slider, .volume-slider {
  width: 100%;
  -webkit-appearance: none;
  height: 5px;
  border-radius: 5px;
  background: #D1D5DB;
  outline: none;
}

.progress-slider::-webkit-slider-thumb,
.volume-slider::-webkit-slider-thumb {
  appearance: none;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
}

.current-font-size {
  font-weight: bold;
  font-size: 16px;
  margin: 0 10px;
}

.bg-music-toggle {
  background: none;
  justify-content: center;
  border: none !important;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  width: 40px !important;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.8;
  transition: all 0.2s ease;
  margin: 0 auto;
}

.bg-music-toggle:hover {
  opacity: 1;
  transform: scale(1.05);
  background-color: rgba(0, 102, 204, 0.1);
}

.bg-music-toggle svg {
  width: 20px;
  height: 20px;
  color: #374151;
}

.time-display {
  min-width: 50px;
  text-align: right;
}

.autoplay-control {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.autoplay-control input[type="checkbox"] {
  margin-right: 10px;
}

.voice-control {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
}

.voice-selector {
  flex: 1 1;
  padding: 0.25em 0.625em;
  border-radius: 4px;
  border: 1px solid #ddd;
  background-color: white;
  cursor: pointer;
  color: #000 !important;
  font-size: 18px !important;
  font-family: "Cripson", serif !important;
  height: 40px;
  border: 1px solid rgba(135, 134, 127, 0.25) !important;
  border-radius: 8px !important;
  background-color: #fff !important;
}

.voice-icon {
  color: #454545;
  font-size: 1.2em;
}

.voice-control select:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0,123,255,.25);
}

.checkbox svg {
  width: 16px !important;
  height: 16px !important;
}

.checkbox .text {
      color: #454545 !important;
    font-family: "Gabarito", serif !important;
        font-size: 15px !important;
}

.select {
  height: 40px !important;
      border: 1px solid rgba(135, 134, 127, 0.25) !important;
    border-radius: 8px !important;
    background-color: #fff !important;
}

.select .option span {
color: #000 !important;
    font-size: 18px !important;
    font-family: "Cripson", serif !important;
}

.play-button {
  margin-bottom: 10px !important;
}

.settings-modal .select:hover,
.settings-modal .btn:hover {
 border: 1px solid rgba(135, 134, 127, 0.5) !important
}

.play-button .icon svg {
  width: 28px !important;
  height: 28px !important;
}

.settings-modal a {
  color: #df2d11;
  text-decoration: none;
}

.settings-modal a:hover {
  text-decoration: underline;
}

.settings-modal small {
  margin-bottom: 20px !important;
  display: block;
  color: #454545 !important;
}

.playback-rate-controls {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 0.5rem;
}

.speed-buttons {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.speed-button {
  min-width: 60px;
}

.speed-button.active {
  background-color: var(--geist-success);
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/Settings/SettingsModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;IACI,eAAe;IACf,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;;AAEA;AACA,2BAA2B;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;;AAEA;;EAGE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,0BAA0B;EAC1B,wCAAwC;EACxC,YAAY;EACZ,sDAAsD;EACtD,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;MACM,yBAAyB;IAC3B,yCAAyC;QACrC,0BAA0B;AAClC;;AAEA;EACE,uBAAuB;MACnB,sDAAsD;IACxD,6BAA6B;IAC7B,iCAAiC;AACrC;;AAEA;AACA,sBAAsB;IAClB,0BAA0B;IAC1B,wCAAwC;AAC5C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;CAEC;AACD;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd","sourcesContent":[".settings-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.settings-modal {\n  background-color: #faf8f5;\n  color: black;\n  padding: 32px 24px;\n  border-radius: 16px;\n  width: 450px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.settings-modal h2 {\n  margin-top: 0;\n  color: black;\n  font-size: 24px;\n  text-align: center;\n  font-family: 'Crimson', serif;\n}\n\n.settings-section {\n    padding: 14px 0;\n    border-bottom: 1px solid rgba(135, 134, 127, 0.25);\n    border-radius: 5px;\n}\n\n.settings-section:last-of-type {\n  border: none;\n}\n\n.settings-section h3 {\n  margin-top: 0;\n  margin-bottom: 10px;\n  color: black;\n  font-size: 18px;\n}\n\n.close-button, .audio-control, .font-size-button {\n  background-color: #f7f4ef;\n  color: black;\n  border: none;\n  border-radius: 5px;\n  border: 1px solid #D1D5DB;\n  padding: 8px 12px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  font-size: 14px;\n}\n\n.close-button:hover, .audio-control:hover, .font-size-button:hover {\ntransition: ease-in-out 0.2;\n}\n\n.close-button {\n  width: 100%;\n  margin-top: 10px;\n}\n\n.volume-control svg {\n  margin-right: 10px;\n  width: 28px !important;\n  height: 28px !important;\n}\n\n.audio-controls, .volume-control, .font-size-controls {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.audio-progress {\n  flex-grow: 1;\n  margin: 0 10px;\n}\n\n.progress-slider, .volume-slider {\n  width: 100%;\n  -webkit-appearance: none;\n  height: 5px;\n  border-radius: 5px;\n  background: #D1D5DB;\n  outline: none;\n}\n\n.progress-slider::-webkit-slider-thumb,\n.volume-slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  background: #fff;\n  cursor: pointer;\n}\n\n.current-font-size {\n  font-weight: bold;\n  font-size: 16px;\n  margin: 0 10px;\n}\n\n.bg-music-toggle {\n  background: none;\n  justify-content: center;\n  border: none !important;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 50%;\n  width: 40px !important;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0.8;\n  transition: all 0.2s ease;\n  margin: 0 auto;\n}\n\n.bg-music-toggle:hover {\n  opacity: 1;\n  transform: scale(1.05);\n  background-color: rgba(0, 102, 204, 0.1);\n}\n\n.bg-music-toggle svg {\n  width: 20px;\n  height: 20px;\n  color: #374151;\n}\n\n.time-display {\n  min-width: 50px;\n  text-align: right;\n}\n\n.autoplay-control {\n  display: flex;\n  align-items: center;\n  margin-top: 10px;\n}\n\n.autoplay-control input[type=\"checkbox\"] {\n  margin-right: 10px;\n}\n\n.voice-control {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 15px;\n}\n\n.voice-selector {\n  flex: 1 1;\n  padding: 0.25em 0.625em;\n  border-radius: 4px;\n  border: 1px solid #ddd;\n  background-color: white;\n  cursor: pointer;\n  color: #000 !important;\n  font-size: 18px !important;\n  font-family: \"Cripson\", serif !important;\n  height: 40px;\n  border: 1px solid rgba(135, 134, 127, 0.25) !important;\n  border-radius: 8px !important;\n  background-color: #fff !important;\n}\n\n.voice-icon {\n  color: #454545;\n  font-size: 1.2em;\n}\n\n.voice-control select:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0,123,255,.25);\n}\n\n.checkbox svg {\n  width: 16px !important;\n  height: 16px !important;\n}\n\n.checkbox .text {\n      color: #454545 !important;\n    font-family: \"Gabarito\", serif !important;\n        font-size: 15px !important;\n}\n\n.select {\n  height: 40px !important;\n      border: 1px solid rgba(135, 134, 127, 0.25) !important;\n    border-radius: 8px !important;\n    background-color: #fff !important;\n}\n\n.select .option span {\ncolor: #000 !important;\n    font-size: 18px !important;\n    font-family: \"Cripson\", serif !important;\n}\n\n.play-button {\n  margin-bottom: 10px !important;\n}\n\n.settings-modal .select:hover,\n.settings-modal .btn:hover {\n border: 1px solid rgba(135, 134, 127, 0.5) !important\n}\n\n.play-button .icon svg {\n  width: 28px !important;\n  height: 28px !important;\n}\n\n.settings-modal a {\n  color: #df2d11;\n  text-decoration: none;\n}\n\n.settings-modal a:hover {\n  text-decoration: underline;\n}\n\n.settings-modal small {\n  margin-bottom: 20px !important;\n  display: block;\n  color: #454545 !important;\n}\n\n.playback-rate-controls {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-top: 0.5rem;\n}\n\n.speed-buttons {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.speed-button {\n  min-width: 60px;\n}\n\n.speed-button.active {\n  background-color: var(--geist-success);\n  color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
